import React from 'react';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

import { hasAssemblyPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../../monitor';
import { deleteAllComponentDesigns } from '../../../../../store/actions/deletionActions';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { ButtonBarButton } from './common';

export function DeleteAllButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const isAssemblyUser = useAppSelector(hasAssemblyPermission);
  const inStation = useAppSelector((state) => state.application.openContext?.type === 'station');

  // currently this button is only implemented as a way for assembly users to clear out a station
  const visible = isAssemblyUser && inStation;
  if (!visible) return null;

  return (
    <ButtonBarButton
      title="Delete All Components"
      icon={DeleteSweepIcon}
      onClick={async () => {
        await dispatch(deleteAllComponentDesigns());
        monitor.recordInteraction('Delete All button clicked');
      }}
    ></ButtonBarButton>
  );
}
